<!--Header container for dsh layout-->
<div class="app-view-header">
    <app-layout-header [title]="name"></app-layout-header>
</div>

<div #dashboard class="app-view-body" appScroll>
    <ng-container *ngIf="!isInitialized">
        <app-load-layout [isDashboard]="true"></app-load-layout>
    </ng-container>

    <!-- Widgets containers of Dashboard -->
    <ng-container *ngIf="isInitialized">
        <div class="row">
            <ng-container
                *ngFor="let widget of viewWidgetCollection; let i = index"
            >
                <div
                    *ngIf="
                        currentMachine &&
                        currentMachine.code &&
                        widget.componentData.objCode === currentMachine.code &&
                        widget.rawComponent.componentId
                    "
                    class="col-xs-12"
                    [ngClass]="widget.componentData.class"
                    [ngSwitch]="widget.presentationType"
                    [id]="widget.rawComponent.componentId"
                >
                    <!--Widget wrapper headed container for widget with title and buttons-->
                    <app-widget-wrapper-headed
                        *ngSwitchCase="1"
                        [configuration]="widget"
                        [delayIndex]="i"
                    >
                    </app-widget-wrapper-headed>

                    <!--widget wrapper to widgets like shiftgroup, without header-->
                    <app-widget-wrapper
                        *ngSwitchDefault
                        [configuration]="widget"
                    >
                    </app-widget-wrapper>
                </div>
            </ng-container>
            <div class="app-footer">
                <app-default-footer></app-default-footer>
            </div>
        </div>
    </ng-container>
</div>
